<template>
  <div
    v-if="adItem && adItem.content"
    style="background: #E6E6E6"
  >
      <v-img
        width="100%"
        aspect-ratio="2"
        contain
        :src="adItem.content"
        class="ad-design"
        @load="successLoad"
        @error="errorLoad"
        @click="goToAdvetisementLink"
      >
        <v-overlay
          :value="ImageAds.loading"
          :opacity="1"
          :absolute="true"
        >
          <v-progress-circular
            indeterminate
            size="64"
          ></v-progress-circular>
        </v-overlay>
      </v-img>
  </div>
</template>
<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  props: {
    adItem: {
      type: Object,
      default: null
    },

    adIndex: {
      type: Number,
      default: null
    }
  } 
})
export default class ImageAd extends Vue {
  data () {
    return {
      ImageAds: {
        loading: true
      }
    }
  }

  successLoad () {
    this.ImageAds.loading = false
  }

  errorLoad () {
    this.$emit('deleteIndex', this.adIndex)
  }

  goToAdvetisementLink () {
    this.$emit('goToAdvetisementLink', this.adItem)
  }
}
</script>
